module.exports = __webpack_public_path__ + "img/402e.c1aa28e3.png";